export default __webpack_public_path__ + "static/media/1476.94171abb.png";